import React from "react";
import { useTranslation } from "react-i18next";

import { LineItem } from "@r6digital/rapidstor-types/types/Merchandise";

import Button from "@/components/elements/button";

import styles from './styles.module.scss';

import BaseModal from "../base";

interface ProductRemovalModalProps {
    show: boolean;
    item: LineItem | null;
    setShow: (show: boolean) => void;
}

export default function ProductRemovalModal({
    show,
    item,
    setShow,
}: ProductRemovalModalProps) {

    const { t } = useTranslation();

    const handleCloseModal = () => {
        setShow(false);
        document.body.style.removeProperty('overflow');
    }

    if (!item) return null;

    return (
        <BaseModal show={show !== false} setShow={handleCloseModal}>
            <div className={styles.body}>
                <p className={styles.productName}>{item.removedText}</p>
                <img
                    className={styles.productImage}
                    src={item.removedImage}
                />
            </div>

            <div className={styles.footer}>
                <Button
                    type={`primary`}
                    size={`medium`}
                    onclick={() => handleCloseModal()}
                    disableScroll={true}
                >{t('cta:close')}</Button>
            </div>
        </BaseModal>
    );
}